<template>
    <div>
        <!--Header Components-->
        <base-header class="pb-6" type="">
        <b-row class="align-items-center py-4">
            <b-col lg="12" cols="12">
            <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
            <h6 class="h2 d-inline-block mb-0">{{language_terms[$route.name]}}</h6>
            <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                <route-breadcrumb/>
            </nav>
            </b-col>
            <!-- <b-col lg="6" cols="5" class="text-right">
            <base-button icon type="neutral" size="lg">
            <span class="btn-inner--icon"><i class="ni ni-fat-add"></i></span>
            <span class="btn-inner--text">New Customer</span>
            </base-button>
            </b-col> -->
        </b-row>
        </base-header>
        <div>
            <!-- <vue-element-loading :active="loading" :is-full-screen="true" color="#fb6340"/> -->
            <loading :active.sync="loading" 
              color= '#007bff'
              :width= '128'
              :height= '128'
              loader='dots'
              :can-cancel="true" 
              :is-full-page="true">
            </loading>
        </div>
        <b-container fluid class="mt--6">
            <b-row>
                <b-col lg="12">
                    <div class="card-wrapper">
                        <b-card>
                            <div slot="header" class="mb-0">
                                <b-row>
                                    <b-col lg="6">
                                        <span style="font-weight: bold">{{ title }} </span>
                                    </b-col>
                                    <b-col lg="6">
                                        <base-button icon type="success" class="float-right mr-5" @click="editLocation"  v-if="is_edit == 0">
                                            <i class="fas fa-edit"></i>
                                        </base-button>
                                    </b-col>
                                </b-row>
                            </div>
                            <b-row>
                                <b-col sm="12">
                                    <base-input v-model="location.name" :label="language_terms['NAME']" :disabled ="!is_edit"></base-input>
                                </b-col>
                                <b-col sm="12">
                                    <base-input :label="language_terms['REMARKS']">
                                        <textarea
                                            class="form-control"
                                            id="exampleFormControlTextarea1"
                                            rows="3"
                                            v-model="location.remarks"
                                            :disabled="!is_edit"
                                        ></textarea>
                                    </base-input>
                                </b-col>
                                <b-col sm="6">
                                    <label class="form-control-label">{{language_terms['STORAGE_CLASSIFICATIONS']}}</label>
                                        <multiselect
                                            :tag-placeholder="language_terms['ADD_NEW_TAG']"
                                            :placeholder="language_terms['SEARCH_ADD_TAG']"
                                            label="storageclassification_name"
                                            track-by="storageclassification_id"
                                            :options="storage_classifications"
                                            text-field="storageclassification_name"
                                            :multiple="true"
                                            v-model="location.storage_classifications"
                                            :taggable="false"
                                            :disabled="!is_edit"
                                            open-direction="bottom"
                                            ></multiselect>

                                </b-col>
                                <b-col sm="6">
                                    <base-input :label="language_terms['PARENT_LOCATION']" :disabled="!is_edit">
                                        <el-select v-model="location.parent_id" filterable :placeholder="language_terms['PARENT_LOCATION']" :disabled="!is_edit">
                                            <el-option v-for="option in active_list"
                                                    :key="option.id"
                                                    :label="option.name"
                                                    :value="option.id">
                                            </el-option>
                                        </el-select>
                                    </base-input>
                                </b-col>
                                <b-col sm="12">
                                    <b-form-checkbox class="mb-3" v-model="location.is_active" value="1" unchecked-value="0" :disabled="!is_edit">
                                        {{language_terms['IS_ACTIVE']}}
                                    </b-form-checkbox>
                                </b-col>
                                <b-col sm="12">
                                    <base-button type="danger" @click="cancel" class="mt-2 float-right">{{language_terms['CANCEL']}}</base-button>
                                    <base-button type="success" @click="save" class="mt-2 mr-4 float-right">{{language_terms['SAVE']}}</base-button>
                                </b-col>
                            </b-row>
                        </b-card>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
    
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import { mapState } from "vuex";

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css'; 
import { Select, Option } from 'element-ui'


export default {
    name:'Location-Details',
    computed:{
        ...mapState({
            language_terms: state => state.languages.language_terms,
            selected_lang: state => state.languages.selected_langauge,
            storage_classifications: state => state.storageclassifications.storage_classifications,
            active_locations: state => state.locations.active_locations,
            location_created: state => state.locations.is_created,
            location_updated: state => state.locations.is_updated,
            location_filter: state => state.locations.filter,
            location_data: state => state.locations.data
        })
    },
    data(){
        return{
            loading:false,
            title:"",
            is_edit:false,
            location:{
                code:'',
                name:'',
                remarks:'',
                storage_classifications:[],
                is_acctive:"1"
            },
            active_list:[]
        }
    },
    components:{
        Loading,
        [Select.name]: Select,
        [Option.name]: Option,
    },
    watch:{
        active_locations: {
            // This will let Vue know to look inside the array
            deep: true,
            handler(){
                this.active_list = this.active_locations
            }
        },
    },
    async mounted()
    {
        this.loading = true
        let code = this.$route.params.id;

        await this.$store.dispatch('storageclassifications/fetchAll', {})
        await this.$store.dispatch('locations/fetchActive', {code:code})

        if(code == '_new')
        {
            this.title = this.language_terms["NEW_LOCATION"]
            this.is_edit = 1
        }
        else
        {
            await this.$store.dispatch("locations/fetch", {code: code})


            this.location = this.location_data
            this.title = code

        }


        this.loading = false
    },
    methods:{
        editLocation()
        {
            this.is_edit = 1
        },
        save()
        {
            if(this.$route.params.id == '_new')
            {
                this.create()
            }
            else
            {
                this.update()
            }
        },
        async searchLocations()
        {
            this.isLoading = true
            let filter = {
                            keyword:"",
                            active_only: "1"
                        }
            if(this.location_filter)
            {
                filter = this.location_filter
            }
            await this.$store.dispatch('locations/quickSearch', filter)

            this.isLoading = false
        },
        routeToMaster()
        {
            this.$router.push("/inventory/locations");

        },
        async create()
        {
            await this.$store.dispatch("locations/create", this.location);

            if(this.location_created)
            {
                await this.searchLocations()
                this.routeToMaster()
            }
        },
        async update()
        {
            await this.$store.dispatch("locations/update", this.location);

            if(this.location_updated)
            {
                await this.searchLocations()
                this.routeToMaster()
            }
        },
        cancel()
        {
            if(this.$route.params.id == '_new')
                this.$router.push("/inventory/locations")
            else
                location.reload();

        }
    }
}
</script>
